import App from './App'
import http from './components/firstui/fui-request'
import store from './store'
import uviewIndex from './utils/uview/index.js'
import route from './utils/uview/route.js'
import uviewTest from './utils/uview/test.js'
import xc from './common/xc-app'
import styleMixin from '@/mixins/style.js'
import $public from '@/utils/public'
import {
	aesEncrypt,
	aesDecrypt,
	rsaEncrypt,
	initAesKey
} from '@/utils/encryption/utils.js'

const $u = {
	test: uviewTest,
	...uviewIndex,
	route
}
uni.$u = $u
uni.$xc = xc
import {
	HTTP_REQUEST_URL,
	HEADER,
	PLATFORM,
	TOKEN_NAME
} from './config/app.js';
import {
	LOGIN_TOKEN_KEY
} from './config/cache.js';

import Cache from './utils/cache.js'
console.log('HTTP_REQUEST_URL', HTTP_REQUEST_URL)
console.log('OS:', uni.$u.os())
// #ifdef APP-PLUS
console.log('渠道:',plus.runtime.channel)
// #endif

//初始化请求配置项
http.create({
	host: HTTP_REQUEST_URL,
	errorMsg: '',
	dataType: 'text',
	header: {
		...HEADER,
		...PLATFORM,
		...{
			'Xc-Os': uni.$u.os()
		},
		'content-type': 'application/x-www-form-urlencoded'
	},
	showLoading: false,
	withCredentials: true,
})
//请求拦截
http.interceptors.request.use(async config => {
	await store.dispatch('secure/initPublicKey')
	let AES_KEY = store.state.secure.aesKey
	let RSA_PUBLIC_KEY = store.state.secure.publicKey
	// console.log('加密-AES_KEY', AES_KEY)
	// console.log('加密-RSA_PUBLIC_KEY', RSA_PUBLIC_KEY)


	//请求之前可在请求头中加入token等信息
	let token = Cache.get(LOGIN_TOKEN_KEY) || '';
	config.header = {
		...(config.header || {}),
		[TOKEN_NAME]: token
	}
	// 如果是开发环境，加上 xc-dev
	let dev = 0
	// #ifdef H5 || APP-HARMONY || MP-WEIXIN
	if (process.env.NODE_ENV === 'development') {
		config.header['Xc-Dev'] = 1
		config.dataType = 'json'
		config.header['content-type'] = 'application/json'
		dev = 1
	}
	// #endif
	if (dev === 0 && config.method &&
		config.method.toLowerCase() !== 'get' && config.data && Object.entries(config.data).length > 0
	) {
		console.log('加密-AES_KEY', AES_KEY)
		console.log('加密-RSA_PUBLIC_KEY', RSA_PUBLIC_KEY)
		console.log('加密-前', config.data)
		const encryptedData = aesEncrypt(JSON.stringify(config.data), AES_KEY)
		console.log('加密-数据', encryptedData)
		const encryptedKey = rsaEncrypt(AES_KEY, RSA_PUBLIC_KEY)
		console.log('加密-KEY', encryptedKey)

		config.data = {
			params: encryptedData,
			encSecKey: encryptedKey
		}
	}
	return config
})
//响应拦截
http.interceptors.response.use(response => {
	//TODO
	console.log('请求结果-拦截', response)
	// if (response.data && response.data.code === -401) {
	// 	console.log('触发注销登录')
	// 	//未登录
	// 	store.commit("logout")
	// }

	let data = response.data
	if (!data) {
		return response
	}

	// 如果 code 存在，说明是正常业务返回，不解密
	if (typeof data.code !== 'undefined') {
		if (data.code === -401) {
			console.log('触发注销登录')
			store.commit("logout")
		}
		return response
	}

	// 否则是加密数据 → 解密
	try {
		const AES_KEY = store.state.secure.aesKey
		console.log('请求结果-数据:', data)

		const decrypted = aesDecrypt(data, 'cb6ca4a67bff8cc3d6e814dda98ffba6')
		console.log('请求结果-解密后:', decrypted)

		response = {
			...response,
			data: JSON.parse(decrypted) || {}
		}
	} catch (e) {
		console.error('请求结果- AES 解密失败:', e)
	}
	// 登录失效
	if (response.data.code === -401) {
		console.log('触发注销登录')
		store.commit("logout")
	}
	console.log('请求结果-response', response)
	return response
})
uni.$zp = {
	config: {
		//配置分页默认pageSize为15
		'default-page-size': 10,
		//配置空数据图默认描述文字为：空空如也~~
		'empty-view-text': '空空如也~~',
		'show-refresher-update-time': true,
		'auto-hide-loading-after-first-loaded': false,
		'auto-show-back-to-top': true
	}
}
uni.$http = http


// #ifdef H5
import {
	showConfirmDialog,
	showDialog,
	closeDialog,
	showLoadingToast,
	closeToast
} from 'vant'
import './node_modules/vant/lib/index.css';

uni.showLoading = (data) => {
	showLoadingToast({
		message: data.title || '请稍后...',
		forbidClick: true,
		duration: 0
	})
}
uni.hideLoading = (data) => {
	closeToast()
}
import h5AsyncLoading from './components/xc-h5-async-loading/xc-h5-async-loading.vue'
// #endif


import {
	createSSRApp
} from 'vue'
export function createApp() {
	const app = createSSRApp(App)
	app.use(store)

	// #ifdef H5
	//安装H5 VANT 组件
	app.component('h5AsyncLoading', h5AsyncLoading);
	// #endif


	app.mixin(styleMixin)
	app.config.globalProperties.xc = xc
	app.config.globalProperties.$http = http
	app.config.globalProperties.$u = $u
	app.config.globalProperties.$public = $public


	// #ifdef H5
	app.config.globalProperties.$showConfirmDialog = showConfirmDialog
	app.config.globalProperties.$showDialog = showDialog
	app.config.globalProperties.$closeDialog = closeDialog
	// #endif

	return {
		app
	}
}